<template>
  <div class="custom-container">
    <div class="ms-cell-editor date" :class="{'cell-error': errorMessage}">
      <div
        v-show="!isSelected || readOnly"
        :class="{
          'edit-disabled': readOnly,
          'ms-editor-text': editable,
          hasError: errorProvider.isValid,
        }"
      >
        <a v-show="!isEditor" @click="$emit('editorClick', $event, col, colIndex)" class="editor-click">
          <span
            class="editor-display text-center"
            :title="[
              dataRow[col.dataField]
                ? $ms.format.formatData(dataRow[col.dataField], {
                    formatType: col.formatType,
                    formatString: col.formatString,
                  })
                : '',
            ]"
            >{{
              dataRow[col.dataField]
                ? $ms.format.formatData(dataRow[col.dataField], {
                    formatType: col.formatType,
                    formatString: col.formatString,
                  })
                : ''
            }}</span
          >
        </a>
        <ms-datepicker
          v-on="listeners"
          v-model="cellData"
          v-if="isEditor"
          :hasTimeInfo="col.formatType == $ms.constant.FormatType.Time"
          :format="col.formatType == $ms.constant.FormatType.Time ? 'HH:mm:ss' : 'DD/MM/YYYY'"
          :onlyDisplayTime="col.formatType == $ms.constant.FormatType.Time"
          :setToCurrentDateTime="col.setToCurrentDateTime"
        />

        <div
          class="icon24 error error-icon mi-icon-error"
          v-show="errorMessage && !isEditor"
          v-tooltip="errorMessage"
        ></div>
      </div>
    </div>

    <v-menu
      ref="optionMenu"
      class="option-wrapper"
      v-if="isEditor && isCopyDataColumn"
      popperClass="option-menu"
      :placement="isAtLastColumn ? 'bottom-start' : 'bottom-end'"
      :skidding="marginSetting"
      :width="menuContentWidth"
      :style="[{right: isAtLastColumn ? 'auto' : optionMenuRight}, {left: isAtLastColumn ? optionMenuLeft : 'auto'}]"
      @show="handleMenuShow"
      :class="dbOptionHeight"
    >
      <div :class="['icon24', 'option-tab-vertical', 'option-custom']"></div>
      <template #popper>
        <menu-item
          v-for="(item, i) in editorActions"
          :key="i"
          @menu-item-click="clickMenuItem(item.id, rowIndex, colIndex)"
          >{{ item.text }}</menu-item
        >
      </template>
    </v-menu>
  </div>
</template>
<script>
import {defineProps, defineEmits, watch, nextTick, defineExpose, getCurrentInstance, computed, inject} from 'vue';
import {useCellEditor} from './CellEditorSetup.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
export default {
  name: 'MsCellDatepicker',
  components: {
    MenuItem,
  },
  props: {
    col: {},
    dataRow: {},
    rowIndex: {
      default: 0,
      type: Number,
    },
    colIndex: {
      default: 0,
      type: Number,
    },
    //Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    rowSelected: {
      default: null,
    },

    readOnly: {
      default: false,
      type: Boolean,
    },
    //có cho phép show text validate bên dưới cell k
    isShowText: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: () => {},
    },
    rules: {
      type: Array,
      default: () => [],
    },
    /**
     * Cấu hình sao chép dữ liệu 1 cột xuống các cột khác (mục đích để dev phải check lại các màn hình đã làm để tránh lỗi dữ liệu)
     * dtnga3 (26.05.2023)
     */
    isCopyDataColumn: {
      default: false,
      type: Boolean,
    },
    optionMenuRight: {
      default: null,
      type: String,
    },
    optionMenuLeft: {
      default: null,
      type: String,
    },
    // Đánh dấu control nằm ở cột cuối hay không
    // dtnga3
    isAtLastColumn: {
      default: false,
      type: Boolean,
    },
    // Độ rộng menu content (cần set để tính toán vị trí của nó)
    // dtnga3
    menuContentWidth: {
      default: 194,
      type: Number,
    },
  },
  emits: ['update:modelValue', 'msKeydown', 'editorClick', 'copyActionClick', 'pasteInput'],
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const col = props.col;
    const rowIndex = props.rowIndex;
    const colIndex = props.colIndex;
    const {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      getValue,
      errorMessage,
      validate,
      clearValidate,
      editorActions,
      clickMenuItem,
      marginSetting,
      handleMenuShow,
    } = useCellEditor({
      props,
      emit,
    });

    watch(isEditor, newVal => {
      if (!newVal) {
        //Đợi flush hết event ở bên control sẽ thực hiện update lại v-model
        nextTick(() => emit('update:modelValue', cellData.value));
      } else {
        cellData.value = props.dataRow[props.col.dataField];
        nextTick(() => {
          findEditor();
        });
      }
    });
    const dbOptionHeight = computed(() => {
      return (
        'heightoptionvalue' +
        parseInt(
          proxy.$store?.state?.dbOption?.dbOptions.HeightOption == 1
            ? proxy.$store?.state?.dbOption?.dbOptions.HeightOption
            : 0,
        )
      );
    });

    const allowCopyFromExcel = inject('allowCopyFromExcel');

    /**
     * Gán giá trị cho cell
     */
    const setValue = value => {
      let me = proxy;

      if (me.readOnly) {
        return;
      }
      let date = me.$ms.commonFn.dateFromString(
        value,
        col.formatType == me.$ms.constant.FormatType.Time ? 'HH:mm:ss' : 'DD/MM/YYYY',
      );
      cellData.value = date;
      nextTick(() => emit('update:modelValue', cellData.value));
    };

    return {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      getValue,
      errorMessage,
      validate,
      clearValidate,
      editorActions,
      clickMenuItem,
      marginSetting,
      handleMenuShow,
      dbOptionHeight,
      setValue,
      allowCopyFromExcel,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/CellAction.scss';
</style>
